import { ROUTER_REQUEST, RouterRequestAction } from '@ngrx/router-store';
import { Action } from '@ngrx/store';
import * as R from 'ramda';

export const isDossierNavigationAction = (action: Action): boolean => {
  if (action.type === ROUTER_REQUEST) {
    const {payload} = action as RouterRequestAction<any>;

    const navigateFromDashboard = R.includes('/dossier/', payload.event.url)
      && R.includes('/dashboard', payload.routerState.url);
    const navigateFromBulkSearch = R.includes('/dossier/', payload.event.url)
      && R.includes('/bulk', payload.routerState.url);

    return navigateFromDashboard || navigateFromBulkSearch;
  }

  return false;
};

export const isLeaveDossierNavigationAction = (action: Action): boolean => {
  if (action.type === ROUTER_REQUEST) {
    const {payload} = action as RouterRequestAction<any>;

    return !R.includes('/dossier', payload.event.url)
      && R.includes('/dossier/', payload.routerState.url);
  }

  return false;
};
